import Style from './LoginMixRegisterBrick.module.less';
import InlineSVG from 'react-inlinesvg';
import FJGoogleLogin from '../common/FJGoogleLogin/FJGoogleLogin';
import FJFaceBookLogin from '../common/FJFacebookLogin/FJFaceBookLogin';
import FJInput from '../common/FJInput/FJInput';
import FJButton from '../common/FJButton/FJButton';
import googleIcon from '../../assets/icon/Google.svg';
import facebookIcon from '../../assets/icon/Facebook.svg';
import FJLocalStore from '../../store/FJLocalStore';
import { useCallback, useEffect, useRef, useState } from 'react';
import logo_small from '../../assets/icon/logo_small.svg';
import classNames from 'classnames';
import FJErrTip from '../common/FJErrTip/FJErrTip';
import useLocalStore from '../../hooks/useLocalStore';
import FJUtil from '../../util/FJUtil';
import FJGoogleLoginNew from '../common/FJGoogleLoginNew/FJGoogleLoginNew';
import FJFacebookLoginNew from '../common/FJFacebookLoginNew/FJFacebookLoginNew';

const LoginMixRegisterBrick = props => {
    useLocalStore();
    let { value, onChange, continueClick, active, hasLogo, popupType, sendGoogleToken, sendFacebookToken } = props;
    const [load, setLoad] = useState(false);
    const [errTip, setErrTip] = useState(null);
    const inputRef = useRef();
    let _emailAccountChange = curValue => {
        _clean();
        onChange(curValue);
    };
    let _clean = () => {
        inputRef.current.setInit();
        setErrTip(null);
    };
    let _formatCheck = useCallback(() => {
        // let reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
        // let reg = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
        // let reg = /^\S+[@][0-9a-zA-Z_.-]+([.][a-zA-Z0-9]+){1,2}$/;
        let reg = /^((?!@)(?!\s).)+[@][0-9a-zA-Z_.-]+([.][a-zA-Z0-9]+){1,2}$/;
        let res = true;
        if (value.length === 0) {
            inputRef.current.setErrorMessage(FJLocalStore._('Enter-Email-Address-here'));
            res = false;
            return res;
        } else {
            inputRef.current.setInit();
        }
        if (reg.test(value)) {
            inputRef.current.setInit();
        } else {
            inputRef.current.setErrorMessage(FJLocalStore._('enter-valid-email'));
            res = false;
            return res;
        }
        return res;
    }, [value]);
    let _clickContinue = useCallback(() => {
        let result = _formatCheck();
        if (!result) {
            return;
        }
        setLoad(true);
        continueClick(option => {
            setLoad(false);
            if (option.networkFail) {
                setErrTip(option.errTip);
            } else if (option.result === true) {
                setErrTip(null);
            } else {
                setErrTip(option.errTip);
            }
        });
    }, [_formatCheck, continueClick]);
    let _text = () => {
        let text = FJLocalStore._('agree-terms-and-policy').replace('</br>', '');
        if (popupType) {
            text = FJLocalStore._('agree-terms-and-policy');
        }
        return text;
    };
    let _enter = useCallback(
        event => {
            if (event.keyCode === 13) {
                _clickContinue();
            }
        },
        [_clickContinue],
    );

    useEffect(() => {
        FJUtil.addEvent(window, 'keydown', _enter);
        return () => {
            FJUtil.removeEvent(window, 'keydown', _enter);
        };
    }, [_enter]);
    return (
        <div
            className={classNames(Style.login_body, {
                [Style.login_body_show]: active,
                [Style.login_body_popup]: popupType,
            })}
        >
            {hasLogo && (
                <div className={Style.logo_box}>
                    <InlineSVG src={logo_small} />
                </div>
            )}
            <div className={Style.minx_header_title}>{FJLocalStore._('login-or-sign')}</div>
            <FJGoogleLoginNew popupType={popupType} />
            <div className={Style.btn_space} />
            {/*<FJFaceBookLogin*/}
            {/*    popupType*/}
            {/*    sendToken={sendFacebookToken}*/}
            {/*    render={(click, setLoadingStatus) => {*/}
            {/*        return (*/}
            {/*            <button onClick={click} className={Style.third_btn}>*/}
            {/*                <div className={Style.third_btn_icon}>*/}
            {/*                    <InlineSVG src={facebookIcon} width={24}/>*/}
            {/*                </div>*/}
            {/*                {FJLocalStore._('continue-facebook')}*/}
            {/*            </button>*/}
            {/*        )*/}
            {/*    }}*/}
            {/*/>*/}
            <FJFacebookLoginNew popupType={popupType} />
            <div className={Style.split_box}>
                <div className={Style.split} />
                <div className={Style.split_text}>{FJLocalStore._('or')}</div>
                <div className={Style.split} />
            </div>
            <FJInput
                value={value}
                onChange={_emailAccountChange}
                label={FJLocalStore._('Email-Address')}
                placeholder={FJLocalStore._('Enter-Email-Address-here')}
                type='text'
                ref={inputRef}
                className={Style.inputMargin}
                inputClassName={Style.input}
                maxInputLength={50}
                popupType={popupType}
                preventAutoComplete
                dataAutoId='Email-Input'
            />
            <FJErrTip errTip={errTip} />
            <FJButton
                text={FJLocalStore._('Continue-with-Email')}
                small={popupType}
                className={Style.submit_btn}
                isLoading={load}
                onClick={_clickContinue}
                dataAutoId='Continue-Button'
            />
            <div className={Style.terms_policy} dangerouslySetInnerHTML={{ __html: _text() }} />
            {/* password输入框为解决谷歌自动填充  影响编辑页和模板页的输入框 其余组件一样 */}
            <input type='password' style={{ height: '0px' }} />
        </div>
    );
};
export default LoginMixRegisterBrick;
